import InitialState from './ServiceControlRequestStatusInitialState'

import listReducer from './list/serviceControlRequestStatusListReducer'

const initialState = new InitialState()

export default function serviceControlRequestStatusReducer(state = initialState, action) {
    let nextState = state

    const list = listReducer(state.list, action)
    if (list !== state.list) nextState = nextState.setIn(['list'], list)

    return nextState
}
